<div class="flex items-center justify-center dialog-header ">
     {{title}}

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div class="text-center">
        <p>
            {{description}}
        </p>
    </div>
    <div class="flex justify-end mt-4">
        <p-button
            label="Delete"
            icon="pi pi-trash"
            severity="danger"
            [loading]="deleteLoading"
            class="flex justify-end"
            icon="pi pi-trash"
            (click)="handleDelete()"
        ></p-button>
    </div>
</div>